import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap, distinctUntilChanged, map } from 'rxjs/operators';
import IExtendedUser = Authorization.IExtendedUser;
import { environment } from 'src/environments/environment';
import { ExtendedUser } from '../models';
import { BaseEntityService } from 'src/shared/services/base-entity.service';

const API = environment.ZONEIQ_AUTHORIZATION_SERVICE + '/api/v1/user';

@Injectable({
    providedIn: 'root'
})
export class UserService extends BaseEntityService<ExtendedUser> {
    constructor(private readonly http: HttpClient) {
        super(ExtendedUser);
    }
    private readonly currentUserSubject = new BehaviorSubject<ExtendedUser>(null);

    public readonly currentUser$ = this.currentUserSubject.asObservable().pipe(
        distinctUntilChanged()
    );

    public getUser(): Observable<IExtendedUser> {
        const url = `${API}/extended`;

        return this.http.get<object>(url).pipe(
            map(response => response as IExtendedUser),
            tap((currentUser) => this.currentUserSubject.next(this.initIfDataExists(currentUser)))
        )
    }
}
